import styled from 'styled-components'

export default styled.div``

export const FieldGroup = styled.div`
  display: grid;
  grid-template-columns: ${(props) =>
      props.width ? `${props.width}px` : 'auto'} 1fr;

  &.stacked {
    display: flex;
    flex-direction: column;
  }

  label {
    font-size: 1.4rem;
    color: black;
    margin-right: 2rem;
    margin-top: 1rem;

    &.error {
      color: ${(props) => props.theme.palette.error};
    }
  }

  .text-editor {
    border: 1px solid ${(props) => props.theme.palette.gray[100]};
    border-radius: 0.6rem;
    height: 4rem;
    padding: 1rem;
    font-size: 1.4rem;
    outline: none;
    width: 100%;
    transition: all 0.2s ease-in-out;
    min-height: 12rem;

    &:hover,
    &:active,
    &:focus {
      border: 1px solid ${(props) => props.theme.palette.gray[200]};
    }

    &.error {
      border-color: ${(props) => props.theme.palette.error};
    }
  }
`

export const Error = styled.div`
  color: ${(props) => props.theme.palette.error};
  font-size: 1.1rem;
  width: 100%;
  display: block;
  padding-top: 0.5rem;
`
